import request, {requestJson} from '../main';
const service = ""
class SysConfigApi {
    private url: string = service + "/sys-config";

    public edit(data: any){
        return requestJson({
            url: this.url + '/edit',
            method: 'post',
            data: data
        })
    }

    public get(){
        return request({
            url: this.url + '/get',
            method: 'get',
        });
    }
}
const sysConfigApi = new SysConfigApi();
export default sysConfigApi
